import * as React from 'react';
import { FilterProps } from '../filters';
import { Op } from '../../../enums/Op';
import { cn, getSchema, isAuditType, parseCondition } from '../../../utils';
import { useSelector } from '../../../utils/useSelector';
import { NodeType } from '../../../enums/NodeType';
import { FieldType } from '../../../enums/FieldType';
import { TypeaheadChecklist } from '../../Typeahead/typeahead';
import { findOne } from 'rcd-cpp-workspace/utils/array';

type RefFilterProps = FilterProps & { inlineMenu?: boolean };

type Opt = { relationType: string; name: string };

export const EmployeeRelationFilter = ({
  filter,
  field,
  setFilter
}: RefFilterProps) => {
  const empRefFields = useSelector(s =>
    getSchema(
      s.planning?.selectedWorkspace?.schemas,
      NodeType.Item
    )?.props?.fields?.filter(
      f =>
        f.fieldType == FieldType.reference &&
        (f.dataType == NodeType.Employee || f.dataType == NodeType.Manager)
    )
  );
  const curFilter = filter;
  let { val } = parseCondition(curFilter.conditions, Op.refIds);
  if (!Array.isArray(val)) val = [];
  const options = (empRefFields || [])
    .sort(
      (a, b) => a.relationProps?.type?.localeCompare(b.relationProps?.type) || 0
    )
    .reduce<Opt[]>((arr, { relationType, name }) => {
      if (isAuditType(relationType)) return arr;
      if (relationType == 'ITEM_TASK') return arr;
      const existed = findOne(arr, { relationType });
      if (existed) {
        existed.name = `${existed.name} / ${name}`;
      } else {
        arr.push({
          relationType,
          name
        });
      }
      return arr;
    }, [])
    .sort((a, b) => a.name?.localeCompare(b.name));

  return (
    <div className="filter-box reference-filter">
      <div>{field.name}&nbsp;</div>
      <div>
        <TypeaheadChecklist
          className={cn('typeahead-schema-field', {
            'typeahead-check': true
          })}
          inline
          options={options}
          selected={t => val.includes(t.relationType)}
          includes={(txt, t) =>
            t.name?.toLowerCase().includes(txt?.toLowerCase())
          }
          onSelect={({ relationType }) => {
            let updatedValues = [];
            if (val.includes(relationType)) {
              updatedValues = val.filter(v => v != relationType);
            } else {
              updatedValues = [...val, relationType];
            }
            setFilter(
              { ...curFilter, conditions: [{ [Op.refIds]: updatedValues }] },
              true
            );
          }}
        />
      </div>
    </div>
  );
};
